export default "__VITE_ASSET__W79az0sd__"